import { GlobalDesignAction } from '../types';
import { getBaseManifestProcessingStrategy } from '../common/grouping/getBaseManifestProcessingStrategy';
import { borderValueFilter } from './valueFilter';
import { borderGrouping } from './grouping';
import BorderLobbyItem from './BorderLobbyItem';
import BorderStyles from './BorderStyles';

const borderAction: GlobalDesignAction<'borderStyles'> = {
  panel: BorderStyles,
  lobbyItem: BorderLobbyItem,
  getManifestProcessingStrategy: getBaseManifestProcessingStrategy,
  // TODO: remove comment after selection implementation
  // valueFilter: borderValueFilter,
  grouping: borderGrouping,
};

export default borderAction;
